var map = {
	"./asset-hyperlink.json": 25994,
	"./blockquote.json": 62559,
	"./document.json": 51734,
	"./embedded-asset-block.json": 1220,
	"./embedded-entry-block.json": 72258,
	"./embedded-entry-inline.json": 92204,
	"./embedded-resource-block.json": 20546,
	"./embedded-resource-inline.json": 8242,
	"./entry-hyperlink.json": 6502,
	"./heading-1.json": 92813,
	"./heading-2.json": 45080,
	"./heading-3.json": 86423,
	"./heading-4.json": 34942,
	"./heading-5.json": 95579,
	"./heading-6.json": 50705,
	"./hr.json": 37121,
	"./hyperlink.json": 13165,
	"./list-item.json": 38094,
	"./ordered-list.json": 28122,
	"./paragraph.json": 38986,
	"./resource-hyperlink.json": 3105,
	"./table-cell.json": 79924,
	"./table-header-cell.json": 91787,
	"./table-row.json": 75531,
	"./table.json": 39269,
	"./text.json": 63022,
	"./unordered-list.json": 58500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37507;